<mat-dialog-content class="mat-typography">
  {{data.message}}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{data.action}}</button>
</mat-dialog-actions>